import type { CrmByChannel } from '@chatbot/shared-types';
import { TIBO_CHANNEL_COLORS } from '../../lib/chart-colors.ts';
import { ChartEmpty } from './chart-theme.tsx';

const CHANNELS: Array<{ key: keyof CrmByChannel; label: string }> = [
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'telegram', label: 'Telegram' },
];

/**
 * Distribución por canal. Dos barras horizontales con etiqueta directa:
 * más legible que una dona de dos porciones y sin dependencia de color.
 */
export function ChannelSplit({
  byChannel,
  motivoVacio,
}: {
  byChannel: CrmByChannel;
  motivoVacio?: string;
}) {
  const total = byChannel.whatsapp + byChannel.telegram;

  if (total === 0) {
    return (
      <div className="h-32" data-testid="chart-by-channel">
        <ChartEmpty message={motivoVacio} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4" data-testid="chart-by-channel">
      {CHANNELS.map(({ key, label }) => {
        const value = byChannel[key];
        const pct = (value / total) * 100;
        return (
          <div key={key} className="flex flex-col gap-1.5">
            <div className="flex items-baseline justify-between text-body-sm">
              <span className="flex items-center gap-2 text-neutral-700 dark:text-neutral-300">
                <span
                  className="h-2.5 w-2.5 rounded-full shrink-0"
                  style={{ backgroundColor: TIBO_CHANNEL_COLORS[key] }}
                  aria-hidden="true"
                />
                {label}
              </span>
              <span className="text-neutral-900 dark:text-neutral-100 tabular-nums">
                <span className="font-semibold">{value.toLocaleString('es-CO')}</span>
                <span className="text-neutral-500 dark:text-neutral-400 ml-2">
                  {pct.toFixed(1)}%
                </span>
              </span>
            </div>
            <div className="h-2.5 w-full rounded-full bg-neutral-100 dark:bg-neutral-700 overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{ width: `${pct}%`, backgroundColor: TIBO_CHANNEL_COLORS[key] }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
